import { render, staticRenderFns } from "./modStudentInfo.vue?vue&type=template&id=1a09a0d0&"
import script from "./modStudentInfo.vue?vue&type=script&lang=js&"
export * from "./modStudentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports